import { useIsGroupFulfilled, useLoadGroup } from '@ms/yammer-hooks/dist/groups';
import React, { FC } from 'react';

import OutboundLegacyRedirectWithGroupIdFulfilled, {
  OutboundLegacyRedirectWithGroupIdFulfilledProps,
} from './OutboundLegacyRedirectWithGroupIdFulfilled';

type OutboundLegacyRedirectWithGroupIdProps = OutboundLegacyRedirectWithGroupIdFulfilledProps;

const OutboundLegacyRedirectWithGroupId: FC<OutboundLegacyRedirectWithGroupIdProps> = ({ target, groupId }) => {
  useLoadGroup(groupId);

  const isGroupFulfilled = useIsGroupFulfilled(groupId);

  if (!isGroupFulfilled) {
    return null;
  }

  return <OutboundLegacyRedirectWithGroupIdFulfilled target={target} groupId={groupId} />;
};

export default OutboundLegacyRedirectWithGroupId;
